import { useEffect } from "react";
import { useTranslation } from "react-i18next";

import { MainLayout } from "@shared/ui/MainLayout";
import { DataGridTable } from "@shared/ui/DataGridTable";
import { ErrorServer } from "@shared/ui/alerts";

import { useVacancyApplications } from "../hooks/useVacancyApplications";

export const CandidateSendPage = () => {
  const {
    t,
    i18n: { language },
  } = useTranslation();
  const { data = [], isFetching, isError } = useVacancyApplications();

  useEffect(() => {
    if (isError) ErrorServer().then();
  }, [isError]);

  const columns = [
    {
      field: "firstName",
      headerName: t("name"),
      flex: 1,
    },
    {
      field: "lastName",
      headerName: t("lastname"),
      flex: 1,
    },
    {
      field: "vacancyName",
      headerName: t("vacancy"),
      flex: 1,
    },
    {
      field: "email",
      headerName: t("emailConsultant"),
      flex: 1,
    },
    {
      field: "interviewDateTime",
      headerName: t("availabilityForInterview"),
      flex: 1,
    },
    {
      field: "status",
      headerName: t("status"),
      flex: 1,
    },
  ];

  return (
    <MainLayout loading={isFetching}>
      <DataGridTable
        rows={data}
        columns={columns}
        title={t("submittedCandidates")}
        language={language}
        height={600}
      />
    </MainLayout>
  );
};
